import type { IconSvgObject } from './types';

const OfficeIcon: IconSvgObject = [
  ["path", { d: "M6.5 11.5H5.5M10.5 11.5H9.5M6.5 7.5H5.5M10.5 7.5H9.5M5.5 15.5H6.5M9.5 15.5H10.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M18 15.5H17M18 11.5H17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M13.5 8.49997V4.5C13.5 3.39543 12.6046 2.5 11.5 2.5H4.5C3.39543 2.5 2.5 3.39543 2.5 4.5V21.5L13.5 21.5M13.5 8.49997H19.5C20.6046 8.49997 21.5 9.3954 21.5 10.5V21.5L13.5 21.5M13.5 8.49997V21.5", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default OfficeIcon;
